<template>
  <span class="badge-box" @click="operatorAndon">
    <AlertOutlined></AlertOutlined>
    <i class="badge" v-if="andonNum > 0">{{ andonNum }}</i>
  </span>
</template>
<script>
  import { AlertOutlined } from '@ant-design/icons-vue'
  import { showAndonList } from '@/api/manual'

  export default {
    props: {
      regionCode: {
        type: String,
        default: '',
      },
    },
    components: {
      AlertOutlined,
    },
    data() {
      return {
        andonNum: 0,
        timer: null,
      }
    },
    created() {
      this.getAndonSum()
      this.timer = setInterval(this.getAndonSum, 30000)
    },
    unmounted() {
      clearInterval(this.timer)
    },
    methods: {
      operatorAndon() {
        this.$router.push({
          name: 'operatorAndon',
          params: { regionCode: this.regionCode },
        })
      },
      async getAndonSum() {
        try {
          const { length } = await showAndonList({
            regionCode: this.regionCode,
          })
          this.andonNum = length
          return Promise.resolve()
        } catch (e) {
          return Promise.reject(e)
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  @import '~@/styles/variables.less';

  .badge-box {
    position: relative;
    .badge {
      position: absolute;
      top: 0;
      right: -5px;
      width: 18px;
      height: 18px;
      font-style: normal;
      line-height: 18px;
      color: #fff;
      text-align: center;
      background: @danger;
      border-radius: 50%;
    }
  }
</style>
